<template>
	<van-popup :value="isPdfViewerShow" position="bottom" :style="{ height: '100%' }">
		<iframe
			:src="computedPdfUrl"
			width="100%"
			height="100%"
			style="position:fixed;left: 0px;top: 0px;"
		></iframe>
		<div class="tool-list">
			<div
				class="tool-item com-active-white copyPdfUrl"
				data-clipboard-action="copy"
				:data-clipboard-text="pdfUrl"
				@click="downloadPdf"
			>
				<span class="adv-download-file"></span>
			</div>
			<div class="tool-item com-active-white" @click="closePdf">
				<span class="adv-cross"></span>
			</div>
		</div>
		<van-dialog v-model="isCopyShow" title="提示" :show-cancel-button="false">
			<div>复制该文档链接失败，请手动复制以下链接并打开浏览器进行下载</div>
			<div><van-field v-model="pdfUrl" rows="1" autosize type="textarea" /></div>
		</van-dialog>
	</van-popup>
</template>

<script>
export default {
	name: 'pdfViewer',
	model: {},
	props: {
		isPdfViewerShow: {
			// 是否显示pdf阅读器
			type: Boolean,
			default: false
		},
		serverUrl: {
			// pdfjs的viewer地址，例如'http://58.241.11.178:18003/mp/pdfjs-2.5.207-es5-dist/web/viewer.html?file='
			type: String,
			default: ''
		},
		pdfUrl: {
			// pdf的网络地址
			type: String,
			default: ''
		},
		pdfName: {
			// pdf的名称
			type: String,
			default: ''
		}
	},
	components: {},
	data() {
		return {
			isPopupShow: false,
			isCopyShow: false
		}
	},
	computed: {
		computedPdfUrl() {
			return `${this.serverUrl}${encodeURIComponent(this.pdfUrl)}`
		}
	},
	created() {},
	watch: {},
	methods: {
		closePdf() {
			this.$emit('close')
		},
		downloadPdf() {
			let _this = this
			let clipboard = new this.clipboard('.copyPdfUrl')
			clipboard.on('success', function() {
				_this.$toast.success({
					message: '该文档链接已复制到粘贴板，请打开浏览器进行下载',
					duration: 3000
				})
			})
			clipboard.on('error', function() {
				_this.isCopyShow = true
			})
		}
	}
}
</script>

<style lang="less" scoped>
.tool-list {
	position: absolute;
	right: 24px;
	bottom: 24px;
	.tool-item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 44px;
		height: 44px;
		font-size: 16px;
		color: #fff;
		border-radius: 50%;
		margin-top: 16px;
		background: #343639;
		opacity: 0.9;
		box-shadow: 0px 24px 90px rgba(0, 0, 0, 0.07), 0px 10px 37.6px rgba(0, 0, 0, 0.05),
			0px 5.4px 20.1px rgba(0, 0, 0, 0.042), 0px 3px 11.3px rgba(0, 0, 0, 0.035),
			0px 1.6px 16px rgba(0, 0, 0, 0.028), 0px 0.7px 2.5px rgba(0, 0, 0, 0.02);
		&:first-child {
			margin-top: 0;
		}
	}
}
</style>
